export default __webpack_public_path__ + "static/media/pizza.201aa166.webp";